<template>
  <a target="_blank"
     :href="url"
     :title="`Twitter status ID ${id}`">
    <slot></slot>
  </a>
</template>
<script>
export default {
  name: 'LinkToTweet',
  props: ['screen_name', 'id'],
  computed: {
    url() {
      if (this.screen_name) {
        return `//twitter.com/${this.screen_name}/status/${this.id}`
      } else {
        return `//twitter.com/i/web/status/${this.id}`
      }
    }
  }
}
</script>
